module.exports = __webpack_public_path__ + "d08539ae479d2722b0ffb785a357d3e4.pdf";